export const classes = {
  row: 'bg-grey-1',
  title: 'mb-2 mt-3',
  table: 'bg-grey-1 border-b-2 border-l border-r border-grey-3',
  dateTime: 'ml-0 mr-2 pb-0 pt-0 w-[200px] shrink-0',
  shareCount: 'w-[140px]',
  priceInput: 'w-[175px]',
  wrapperCell: 'px-0 py-0',
  headCell:
    'py-3 px-2 bg-grey-2 text-grey-6 tracking-wide uppercase font-semibold text-xs',
  cell: 'p-2',
  editCell: 'py-2 border border-solid border-grey-3',
  percentage: 'text-sm font-semibold ml-2',
  positive: 'text-green-text',
  negative: 'text-red-3',
  price: 'text-sm font-semibold text-grey-6',
  actionsCell: 'flex py-2',
  optionsCell: 'flex options-cell p-2',
};

export const styles = {
  row: {
    '& .options-cell': {
      opacity: 0,
    },
    '&:hover .options-cell': {
      opacity: 1,
    },
  },
};
